var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 6.66675H9.99999C8.15832 6.66675 6.66666 8.15841 6.66666 10.0001V40.0001C6.66666 41.8417 8.15832 43.3334 9.99999 43.3334H40C41.8417 43.3334 43.3333 41.8417 43.3333 40.0001V10.0001C43.3333 8.15841 41.8417 6.66675 40 6.66675ZM18.2567 36.6667H13.34V20.8467H18.2567V36.6667ZM15.7483 18.5851C14.1633 18.5851 12.8817 17.3001 12.8817 15.7184C12.8817 14.1367 14.165 12.8534 15.7483 12.8534C17.3283 12.8534 18.6133 14.1384 18.6133 15.7184C18.6133 17.3001 17.3283 18.5851 15.7483 18.5851ZM36.6733 36.6667H31.76V28.9734C31.76 27.1384 31.7267 24.7784 29.205 24.7784C26.6467 24.7784 26.2533 26.7767 26.2533 28.8401V36.6667H21.34V20.8467H26.0567V23.0084H26.1233C26.78 21.7651 28.3833 20.4534 30.775 20.4534C35.7533 20.4534 36.6733 23.7301 36.6733 27.9901V36.6667V36.6667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b3ea2739182f3a58661f0b3104b4936e.svg";
export { ForwardRef as ReactComponent };